import { render, staticRenderFns } from "./FormPaqueteDirectorio.vue?vue&type=template&id=8d1f83f0"
import script from "./FormPaqueteDirectorio.vue?vue&type=script&lang=js"
export * from "./FormPaqueteDirectorio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports